import { render } from "./ServicesList.vue?vue&type=template&id=25ec15bc&scoped=true"
import script from "./ServicesList.vue?vue&type=script&lang=js"
export * from "./ServicesList.vue?vue&type=script&lang=js"

import "./ServicesList.vue?vue&type=style&index=0&id=25ec15bc&lang=scss&scoped=true"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ec15bc"]])

export default __exports__